import React, { useEffect, useState } from 'react';
/* import { Container, Grid, Paper, Typography, Button, Box, Divider } from '@mui/material'; */
import { styled } from '@mui/material/styles';
import { Address, Billing, Contact, Copy, Customer, CustomerInfo, download, EmailBox, Filter, Payment, Phone, Shipping, ShippingID, ShippingMethod, Users } from '../../Svg';
import NestedUserHeader from '../../component/reusable/NestedUserHeader';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { getAllAdminThunk } from '../../redux/admin/adminSlice';
import { getVendorDetailsThunk, vendorrejectOrAproveThunk } from '../../redux/vendor/vendorSlice';
import { exportDataExcel, fomateDate, handleCopy } from '../../utils/fomateDate';
import AssignModal from '../../component/reusable/assignModal/AssignModal';
import {
  MenuItem,
  Menu,
  Button,
  Paper,
  Typography,
  Box,
  Divider, Grid

} from "@mui/material";
import OrderDetailsProds from '../../component/ordersComps/OrderDetailsProds';
import { ArrowDropDown } from '@mui/icons-material';
import PartList from '../../component/bomComps/PartList/PartList';
import EnquiryList from '../../component/wizardComps/EnquiryList/EnquiryList';
import api from '../../utils/api';
import { deleteProductFromwizardThunk, setwizardrefresh, wizardDetailsThunk } from '../../redux/wizardSlice';
import { toast } from 'react-toastify';

const StyledGrid = styled(Grid)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderRadius: theme.shape.borderRadius,
}));

const ActionButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  marginRight: theme.spacing(1),
  fontSize: '0.875rem',
  color: '#512DA8',
  backgroundColor: '#F0F1F3',
  fontSize: '14px',
  fontWeight: '600 !important',
  fontFamily: `'Public Sans', sans-serif`,
  borderRadius: '8px',
  '&:hover': {
    backgroundColor: theme.palette.grey[200],
  },
}));


const WizardEnquiresDetails = (setStatus,) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const { id } = useParams()
  const { loading, refresh, wizardEnquiryDetails } = useSelector((state) => state.wizard);
  const enqdetails = encodeURIComponent(JSON.stringify(wizardEnquiryDetails));
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (status) => {
    if (status) {
      changeStatus(status)
    }
    setAnchorEl(null);
  };


  useEffect(() => {
    dispatch(wizardDetailsThunk(id))
  }, [refresh])

  const changeStatus = async (status) => {
    const datas = {
      id: wizardEnquiryDetails?._id,
      status: status
    }
    try {
      const { data } = await api.updatewizardStatus(datas)
      if (data) {
        toast.success('status updated succesfully')
        dispatch(setwizardrefresh())
      }
    } catch (err) {
      console.log(err);
      toast.error(err?.response?.data?.message || 'something went wrong')
    } finally {
    }
  }


  const deleteProductFromenq = (selectedId) => {
    const data = {
      id: wizardEnquiryDetails?._id,
      partId: selectedId
    }
    dispatch(deleteProductFromwizardThunk(data))

  }

  if (loading) {
    return (
      <div>please wait...</div>
    )
  }


  const downLoadPo = () => {
    const data = wizardEnquiryDetails?.partList?.map((pro) => ({
      "productNumber": pro?.productNumber,
      "quantity": pro?.quantity,
      "manufacturer": pro?.manufacturer
    }))
    exportDataExcel(data, 'wizard Po')
  }




  return (
    <>
      <NestedUserHeader
        index="Wizard enquiry details"
        root="Dashboard"
        buttonText={'Quote Now'}
        onClickadd={() => navigate(`/wizard/wizardQuote/${wizardEnquiryDetails?.enquiryId}`)}
        show={wizardEnquiryDetails?.status === 'COMPLETED' ? false : true}
      />


      <div style={{ borderLeft: "1px solid #DCDEE3", padding: "10px 20px" }}>
        <div style={{ display: 'flex', justifyContent: "space-between", padding: '20px 0px' }}>
          <div style={{ display: 'flex' }}>
            <Typography
              sx={{
                color: 'rgba(29, 31, 44, 1)',
                fontSize: '20px',
                fontWeight: '600',
                fontFamily: `'Public Sans', sans-serif`,
              }}>
              ID #{wizardEnquiryDetails?.enquiryId}
            </Typography>
            <Typography style={{
              marginLeft: '10px', padding: "6px 4px", borderRadius: '8px', fontSize: '14px', fontWeight: "600",
              color: wizardEnquiryDetails?.status === "NEW" ? "#4A4C56" : wizardEnquiryDetails?.status === "QUOTED" ? "#00B789" : "#1A9882",
              background: wizardEnquiryDetails?.status === "NEW" ? "#4A4C561A" : wizardEnquiryDetails?.status === "QUOTED" ? "#EAFFFE" : "#E9FAF7",
            }}>
              {wizardEnquiryDetails?.status}
            </Typography>
          </div>
          {/* {wizardEnquiryDetails?.status != "COMPLETED" &&
            <div>
              <ActionButton
                onClick={handleClick}
                sx={{
                  color: '#667085',
                  border: '1px solid #E0E2E7',
                  background: '#fff',
                  borderRadius: '8px',
                }}
              >
                {wizardEnquiryDetails?.status}
                <ArrowDropDown />
              </ActionButton>
              <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={() => handleClose('')}
                MenuListProps={{
                  'aria-labelledby': 'status-button',
                }}
              >
                {status?.map((i) => (

                  <MenuItem onClick={() => handleClose(i)}
                    sx={{
                      borderBottom: '1px solid #E6E1E5',
                      fontSize: '14px',
                      color: '#667085',
                    }}>{i}</MenuItem>
                ))
                }
              </Menu>
            </div>
          } */}
        </div>

        {loading ? <div>Please wait...</div> :
          <Box maxWidth="lg">
            <Grid container spacing={3}>
              <Grid item xs={12} md={7}>
                <Paper sx={{ height: '100%', boxShadow: '0px 4px 30px 0px #4D54640D', border: '1px solid #DCDEE3', borderRadius: "16px" }}>
                  <Box sx={{ p: 2, }} display="flex" alignItems="center" >
                    <CustomerInfo />
                    <Typography style={{ marginLeft: '10px', fontSize: '18px' }}>
                      Customer Info
                    </Typography>
                  </Box>
                  <Divider sx={{ mb: 1 }} />
                  <Box sx={{ p: '24px 24px 0px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
                    <Box display="flex" >
                      <Customer />
                      <Box style={{ marginLeft: '8px', }} display="flex" gap='20px'>
                        <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', marginBottom: '4px', }}>
                          Customer:
                        </Typography>
                        <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                          {wizardEnquiryDetails?.userId?.companyName}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                  <Box sx={{ p: '24px 24px 0px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
                    <Box display="flex" >
                      <EmailBox />
                      <Box style={{ marginLeft: '8px', }} display="flex" gap='20px'>
                        <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', marginBottom: '4px', }}>
                          Email:
                        </Typography>
                        <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                          {wizardEnquiryDetails?.userId?.email}
                        </Typography>
                      </Box>
                    </Box>
                    <Box>
                      <div onClick={() => handleCopy(wizardEnquiryDetails?.userId?.email)}>
                        <Copy />
                      </div>
                    </Box>
                  </Box>
                  <Box sx={{ p: '24px 24px 0px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
                    <Box display="flex" >
                      <Phone />
                      <Box style={{ marginLeft: '8px', }} display="flex" gap='20px'>
                        <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', marginBottom: '4px', }}>
                          Phone Number:
                        </Typography>
                        <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                          {wizardEnquiryDetails?.userId?.phone}
                        </Typography>
                      </Box>
                    </Box>
                    <Box>
                      <div onClick={() => handleCopy(wizardEnquiryDetails?.userId?.phone)}>
                        <Copy />
                      </div>
                    </Box>
                  </Box>
                  <Box sx={{ p: '18px 24px 14px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
                    <Box display="flex" >
                      <Address />
                      <Box style={{ marginLeft: '8px', }} display="flex" gap='20px'>
                        <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', marginBottom: '4px', }}>
                          Shipping Address:
                        </Typography>
                        {wizardEnquiryDetails?.userId?.shippingAddress?.map((i) => (
                          <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                            {i?.factoryUnits} <br /> {i?.streetAddress},{i?.state}-{i.zipCode}, {i?.country}
                          </Typography>
                        ))
                        }
                      </Box>
                    </Box>
                  </Box>
                </Paper>
              </Grid>


              <Grid item xs={12} md={5}>
                <Paper sx={{ boxShadow: '0px 4px 30px 0px #4D54640D', border: '1px solid #DCDEE3', borderRadius: "16px" }}>
                  <Box sx={{ p: 2, }} display="flex" alignItems="center" >
                    <Contact />
                    <Typography style={{ marginLeft: '10px', fontSize: '18px' }}>
                      Enquiry Info
                    </Typography>
                  </Box>
                  <Divider sx={{ mb: 1 }} />
                  <Box sx={{ p: '24px 24px 24px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
                    <Box display="flex" flexDirection="column" gap='10px'>
                      <Box style={{ marginLeft: '8px', }} display="flex" gap='20px' alignItems='center'>
                        <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', marginBottom: '4px', }}>
                          wizard PO:
                        </Typography>
                        <Typography style={{ color: '#2D7BE8', fontSize: '14px', display: 'flex', alignItems: 'center', gap: 5 }} >
                          <div onClick={downLoadPo} style={{ cursor: 'pointer' }}>

                            wizard po.excel {download()}
                          </div>
                        </Typography>
                      </Box>


                    </Box>
                  </Box>
                </Paper>
              </Grid>


            </Grid>
            <EnquiryList
              data={wizardEnquiryDetails?.partList}
              deleteProductFromenq={deleteProductFromenq}
              status={wizardEnquiryDetails?.status}
            />

          </Box>
        }
      </div>
    </>
  );
};

export default WizardEnquiresDetails;
